import * as React from "react"
import styles from "../../../styles/components/Product/Reviews/Reviews-tw-styles"
import RichText from "../RichText/Richtext"
import Rating from "../Rating"
import Typography from "../Typography/Typography"
import PropTypes from "prop-types"

const ReviewCard = ({ cardData, singleCheck }) => {
    const {
        ReviewCard: { reviewCard, ReviewCardOne, description, reviewerName, source, ReviewSectionRating }
    } = styles
    return (
        <div className={(singleCheck !== true) ? reviewCard : ReviewCardOne}>
            {cardData.rating && <Rating ratingData={cardData.rating} ratingStyle={ReviewSectionRating}/>}
            {cardData.description && (
                <RichText
                    className={description}
                    richTextJson={cardData.description}
                />
            )}
            {cardData.reviewerName && (
                <Typography className={reviewerName}>{cardData.reviewerName}</Typography>
            )}
            {cardData.source && <Typography className={source}>{cardData.source}</Typography>}
        </div>
    )
}
ReviewCard.propTypes = {
    cardData: PropTypes.object,
    singleCheck: PropTypes.any
}
export default ReviewCard
